import type { ParagraphText as ParagraphTextData } from "@/lib/api/cms-catalog";
import { ParagraphHeading } from "../shared/ParagraphHeading";
import type { ParagraphTranslations } from "../Paragraph.i18n";
import { HtmlText } from "../shared/HtmlText";
import { Attachments } from "../shared/Attachments";
import styles from "../Paragraph.module.css";

/**
 * Layout 1 — `PARAGRAPH_TEXT_LAYOUT`: tylko tekst + opcjonalny nagłówek + załączniki.
 */
export function ParagraphText({
  paragraph,
  t,
}: {
  paragraph: ParagraphTextData;
  t: ParagraphTranslations;
}) {
  return (
    <section className={styles.paragraph}>
      <ParagraphHeading name={paragraph.name} centerHeader={paragraph.center_header} />
      <HtmlText html={paragraph.text} />
      <Attachments files={paragraph.attachments} t={t} />
    </section>
  );
}
